export const ACR_MISC_COST_SET = 'ACR_MISC_COST_SET';
export const ACR_EDIT_SET = 'ACR_EDIT_SET';
export const ACR_SAVING_SET = 'ACR_SAVING_SET';
export const ACR_ADDITIONAL_COST_SET = 'ACR_ADDITIONAL_COST_SET';
export const ACR_ADDITIONAL_COST_DESC_SET = 'ACR_ADDITIONAL_COST_SET';
export const ACR_ADDITIONAL_COST_EDIT_SET = 'ACR_ADDITIONAL_COST_EDIT_SET';
export const ACR_ADDITIONAL_COST_SAVING_SET = 'ACR_ADDITIONAL_COST_SAVING_SET';
